const searchParams = new URLSearchParams(window.location.search);
const pageSize = searchParams.get('pageSize');
const pageNumber = searchParams.get('pageNumber');

export const eligibilityInitialState = {
	fingerprintsList: [],
	isSetBlockLoading: false,
	isBlockListLoading: false,
	blockList: null,
	blockListTotalItemCount: 0,
	blockListTablePageNumber: Number(pageNumber) ? Number(pageNumber) - 1 : 0,
	blockListTablePageSize: Number(pageSize) || 10,
};
